<!--
 * @Author: wh
 * @Date: 2020-08-13 21:44:37
 * @LastEditTime: 2020-09-13 10:58:52
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \Web\JiYun.Mobile\src\views\jnApp\salesReport\default.vue
-->
<template>
    <div class="jn-salesreport">
        <van-nav-bar
            left-text=""
            left-arrow
            @click-left="onClickLeft"
        >
            <!-- <template #title>
                <div
                    :class="{'active': activeIndex === index}"
                    v-for="(item, index) in menus"
                    :key="index"
                    @click="clickMenu(index)"
                >
                    {{ item.name }}
                </div>
            </template> -->
            <template #title>
                <van-tabs
                    v-model="activeIndex"
                    animated
                    @click="toggletab"
                >
                    <template v-for="(item,index) in menus">
                        <van-tab
                            :key="index"
                            :title="item.name"
                        >
                        </van-tab>
                    </template>
                </van-tabs>
            </template>
        </van-nav-bar>
        <div class="wrapper">
            <component :is="currentView"></component>
        </div>
    </div>
</template>

<script>
import currentSales from './currentSales';
import yearSales from './yearSales';
export default {
    components: {
        currentSales,
        yearSales,
    },
    props: {},
    data() {
        return {
            currentView: 'currentSales',
            // 菜单
            menus: [
                { name: '当前销量', value: 'currentSales' },
                { name: '年度销量', value: 'yearSales' },
            ],
            activeIndex: 0,
        };
    },
    watch: {},
    computed: {},
    created() {},
    mounted() {},
    methods: {
        onClickLeft() {
            this.$router.isBack = 1;
            this.$router.go(-1);
        },
        toggletab(index) {
            this.activeIndex = index;
            this.currentView = this.menus[index].value;
        },
    },
};
</script>
<style lang="stylus">
.jn-salesreport
    background #F0F0F0
    width 100%
    height 100%
    display flex
    flex-direction column
    .van-nav-bar
        display flex
        .van-nav-bar__title
            /* max-width calc(100% - 80rpx) */
            margin-left 45rpx
            .van-tabs
                .van-tabs__nav
                    background rgba(0,0,0,0)
                    .van-tab
                        flex-basis auto !important
                        font-size 14rpx
                        margin 0 20rpx
                        line-height 44rpx
                        color rgba(240,240,240,0.5)
                        transition 0.2s
                        &.van-tab--active
                            font-size 16rpx
                            line-height 44rpx
                            color #FFFFFF
                        .van-tab__text
                            white-space nowrap
                    .van-ellipsis
                        text-overflow initial
                    .van-tabs__line
                        display none
                .van-tabs__wrap
                    &:after
                        display none
        .van-ellipsis
            white-space normal
        .van-nav-bar__right
            width 0
    .wrapper
        height calc(100% - 45rpx)
        flex 1
    .van-nav-bar__title
        /* max-width 80% */
        margin: 0 auto!important
</style>